import { useEffect, useRef } from 'react';
import { useNotification } from '../contexts/NotificationContext';

export const useSocketConnection = (user: any) => {
  const { connectSocket, isConnected, loadNotifications } = useNotification();
  const hasConnected = useRef(false);
  const currentUserId = useRef<string | null>(null);

  useEffect(() => {
    if (user && (user.role === 'employee' || user.role === 'admin') && !hasConnected.current && !isConnected) {
      if (currentUserId.current !== user.id) {
        hasConnected.current = true;
        currentUserId.current = user.id;
        
        console.log('Connecting socket for user:', user.id, 'role:', user.role);
        
        loadNotifications().then(() => {
          if (user.role === 'admin') {
            connectSocket(undefined, true);
          } else {
            connectSocket(user.id, false);
          }
        });
      }
    }

    return () => {
      if (currentUserId.current !== user?.id) {
        hasConnected.current = false;
        currentUserId.current = null;
      }
    };
  }, [user, connectSocket, isConnected, loadNotifications]);
}; 